import {
    AccountCategory,
    OtherCategory,
} from "@/entities/DataAssociation/Account.model";
import { DraftAccount } from "@/entities/DataAssociation/Draft.model";
import { ExistingAccountList } from "./ExistingAccountList";
import { PseudoAccountList } from "./PseudoAccountList";
import { LabelCategoryMenu } from "../LabelCategoryMenu";
import { labelsByStatementType } from "../../constants/labelsByStatementType";
import { LabelListStatementType } from "../../Labeling.types";
import { ACCOUNT_LIST } from "../../constants/labeling.constants";

export function AccountSelection({
    hint,
    statementType,
}: {
    hint?: DraftAccount;
    statementType: LabelListStatementType;
}) {
    const categories = Object.keys(
        labelsByStatementType[statementType],
    ) as AccountCategory[];

    return (
        <LabelCategoryMenu
            categories={categories}
            initalCategory={
                hint?.label ? ACCOUNT_LIST[hint.label].category : undefined
            }
        >
            {(props) =>
                props.selectedCategory === OtherCategory.EXCLUDED ||
                props.selectedCategory === OtherCategory.REPORTED ? (
                    <PseudoAccountList
                        selectedCategory={props.selectedCategory}
                    />
                ) : (
                    <ExistingAccountList
                        hint={hint}
                        selectedCategory={props.selectedCategory}
                    />
                )
            }
        </LabelCategoryMenu>
    );
}
